import { all, fork } from 'redux-saga/effects';

import api from 'api/saga';
import external from 'store/external/saga';
import fields from 'store/field/saga';
import history from 'store/history/saga';
import printRender from 'store/printRender/saga';
import process from 'store/process/saga';
import scanConfig from 'store/processScanConfig/saga';
import processScanning from 'store/processScanning/saga';
import reduxForm from 'store/reduxForm/saga';
import registration from 'store/registration/saga';
import scanDocumentView from 'store/scanDocumentView/saga';
import splitDocuments from 'store/splitDocuments/saga';
import users from 'store/users/saga';

const sagas = [
  process,
  api,
  registration,
  history,
  scanDocumentView,
  fields,
  users,
  printRender,
  external,
  reduxForm,
  scanConfig,
  processScanning,
  splitDocuments,
];

export default function* rootSaga() {
  yield all(sagas.map((saga) => fork(saga)));
}
